import { render, staticRenderFns } from "./infoGroupDialog.vue?vue&type=template&id=500e8046&"
import script from "./infoGroupDialog.vue?vue&type=script&lang=js&"
export * from "./infoGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports